import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export function createHandbookItemStyles({ spacing }: Theme) {
  return {
    root: css({
      display: "flex",
      alignItems: "center",
      padding: spacing(2),
      borderTop: `1px solid ${grey[250]}`,

      "&:last-child": {
        borderBottom: `1px solid ${grey[250]}`,
      },
    }),
    name: css({
      flex: 1,
      color: grey[900],
    }),
    button: css({
      outline: "none",
      border: "none",
      backgroundColor: "transparent",
      padding: 0,
      height: 22,
    }),
    buttonIcon: css({
      color: grey[800],
      width: 22,
      height: 22,

      "&:active": {
        color: grey[900],
      },
    }),
  };
}
